import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { postLinkedCalendar, deleteLinkedCalendar } from "services/ConfigServices";
import useLinkedCalendarsTable from "./useLinkedCalendarsTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { linkedcalendartext } from "variables/MBM/schedule";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import LinkedCalendarDialog from "./LinkedCalendarDialog";
import FileCopyIcon from '@mui/icons-material/FileCopy';

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTLinkedCalendars = (props) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const { wpgroup} = props;
  const [open, setOpen] = useState(false);
  const [currentCalendar, setCurrentCalendar] = useState(null);
  const { gridState, refetch, setSelectedCalendars, setLoading } = useLinkedCalendarsTable(wpgroup);


  const classes = useStyles();

  const columns = [
    {
      name: linkedcalendartext.name,
      selector: (row) => row.parameters?.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.name,
    },
    {
      name: linkedcalendartext.url,
      selector: (row) => row.parameters?.url,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters?.url,
    },
    {
      name: linkedcalendartext.refreshtime,
      selector: (row) => row.parameters?.refreshtime,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.parameters?.refreshtime,
    },
    {
      name: linkedcalendartext.lastsynchronization,
      selector: (row) => row.parameters?.lastsynchronization,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lastsynchronization && moment(row.lastsynchronization).isValid()
          ? moment(row.lastsynchronization).format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: linkedcalendartext.group,
      selector: (row) => row.groupid,
      sortable: true,
      //  maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {mbm_geb_control_schedules ? (
              <>
                <Tooltip title="Editer le lien">
                  <Button
                    onClick={editLinkedCalendar(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Supprimer le lien">
                  <CustomDeleteButton
                    deleteTitle={"Suppression du lien"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le lien ${row.parameters?.name}?`}
                    handleSupprimer={deleteLinkedCalendarFunction(row)}
                  />
                </Tooltip>
              </>
            ) :
              <>
                <Tooltip title="Voir le lien">
                  <Button
                    onClick={editLinkedCalendar(row)}
                    color={"info"}
                    className={classes.actionButton}
                  >
                    <VisibilityIcon fontSize="large" />
                  </Button>
                </Tooltip>
              </>
            }
          </div>
        </>
      ),
    },
  ];


  const ExpandableComponent = props => {
    const { data } = props;
    return (
      <Container>

      </Container>
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editLinkedCalendar = (row) => async () => {
    let obj = gridState.data.find((o) => o.id === row.id);
    if (obj) {
      setCurrentCalendar(obj);
      handleClickOpen();
    }
  }


  const deleteLinkedCalendarFunction = (row) => async () => {
    let obj = gridState.data.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteLinkedCalendar(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le lien a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedCalendars(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun lien à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        // expandOnRowClicked={true}
        // expandableRows={true}
        // expandableRowDisabled={(row) => row.disabled}
        // expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification d'un planning
        </CustomDialogTitle>
        <DialogContent dividers>
          <LinkedCalendarDialog
            closeModal={handleEditClose}
            setLoading={setLoading}
            setNotification={setNotification}
            refetch={refetch}
            currentCalendar={currentCalendar}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTLinkedCalendars;
